import { useCurrentUserWithRole } from '../../../../../../../../../courses/hooks';
import { selectAccessibilityPrefs } from '../../../../../../../../../db/app/selectors';
import { deleteComment } from '../../../../../../../../../db/comments/actions';
import { selectComment } from '../../../../../../../../../db/comments/selectors';
import { useAppSelector } from '../../../../../../../../../store/hooks';
import { useRequestDispatch } from '../../../../../../../../../utils/request-actions';
import { getCanRemoveComment } from '../../../../../../../../helpers';

export interface Props {
  commentId: MongoId;
}

const useDeleteVM = ({ commentId }: Props) => {
  const requestDispatch = useRequestDispatch();

  const { turnOff } = useAppSelector((state) => selectAccessibilityPrefs(state));
  const isScreenReaderOn = !turnOff;

  const comment = useAppSelector((state) => selectComment(state, commentId));
  const currentUser = useCurrentUserWithRole();

  const canRemove = getCanRemoveComment(comment, currentUser);

  const handleDeleteComment = async () => {
    await requestDispatch(deleteComment, { commentId });
  };

  return { isScreenReaderOn, canRemove, handleDeleteComment };
};

export default useDeleteVM;
